import React from "react";
import { LegalLayout, LegalSection } from "@/components/LegalLayout";

export default function TermsConditions() {
  return (
    <LegalLayout
      testid="terms-conditions-page"
      title="Terms & Conditions"
      intro="Welcome to turahtidclothing.com. By using our site, you agree to these terms."
    >
      <LegalSection heading="Payment & Pricing">
        All prices are displayed in JMD / USD. Transactions are processed securely via Sagicor Bank merchant gateway. We do not store full credit card information on our servers.
      </LegalSection>
      <LegalSection heading="Order Fulfillment">
        Orders are processed within 1–3 business days. Delivery times vary depending on parish or international destination.
      </LegalSection>
      <LegalSection heading="Merchant Address & Operations">
        turahtidclothing.com operates out of May Pen, Clarendon, Jamaica.
      </LegalSection>
      <LegalSection heading="Governing Law">
        These terms are governed by the laws of Jamaica. Any disputes shall be subject to the exclusive jurisdiction of the courts of Jamaica.
      </LegalSection>
    </LegalLayout>
  );
}
